import React from 'react'
import { usePutRequest } from '../../../hooks/request'
import { TECH_CATEGORY_DETAIL } from '../../../urls'
import TechCategoryForm from './TechCategoryForm'

export default function TechCategoryUpdate({ onCancel, onSuccess, item }) {
    const brandUpdate = usePutRequest({ url: TECH_CATEGORY_DETAIL.replace('{id}', item.id) })

    async function onSubmit(data) {
        const { success } = await brandUpdate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Изменить</b>
            </h1>
            <TechCategoryForm loading={brandUpdate.loading} initialValues={item} onSubmit={onSubmit}
                onCancel={onCancel} />
        </div>
    )
}
